export function lightning(params) {
  const methods = {};
  return methods[params.type] || this._SEND(params);
}



// WEBPACK FOOTER //
// ./src/proxy/lightning.js